import i18n from 'i18next';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import CustomAlertModal from '@library/modals/CustomAlert.modal';
import LoginModal from '@nedoShared/modules/auth/Login.modal';
const actionConfirmatorConfig = {
    checkAuth: {
        modalTemplate: LoginModal,
        enabled: true,
        skip: () => $auth.isLogged,
    },
    customAlert: {
        modalTemplate: CustomAlertModal,
        enabled: true,
        data: {
            done: () => i18n.t('btn.confirm'),
            cancel: () => i18n.t('btn.cancel'),
        },
    },
};
export default actionConfirmatorConfig;
